/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputPositionShort
 */
export interface OutputPositionShort {
    /**
     * 
     * @type {number}
     * @memberof OutputPositionShort
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputPositionShort
     */
    name: string;
}

/**
 * Check if a given object implements the OutputPositionShort interface.
 */
export function instanceOfOutputPositionShort(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputPositionShortFromJSON(json: any): OutputPositionShort {
    return OutputPositionShortFromJSONTyped(json, false);
}

export function OutputPositionShortFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputPositionShort {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputPositionShortToJSON(value?: OutputPositionShort | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

